module.exports = __webpack_public_path__ + "img/list-tick.6acefd31.svg";